<template>
    <el-dialog :title="$t('serviceTickets.selectCategory') + ' ' + ticketId + ' ' + $t('serviceTickets.details')"
               :visible.sync="showDialog"
               @open="loadTicket"
               @close="closeDialog"
               width="650px"
               append-to-body
               :close-on-click-modal="false"
               :disable="loading">
        <el-row :gutter="10">
            <el-col :span="9">
                <dl>
                    <dt v-if="details.confirmation">{{details.confirmationText}}</dt>
                    <dt>Opened by</dt>
                    <dd>{{details.openedBy}}</dd>
                    <dt>Opened on</dt>
                    <dd>{{details.raisedOn | date}}</dd>
                    <dt>Dispatched to</dt>
                    <dd v-html="details.dispatchedTo"></dd>
                    <dt>Urgency</dt>
                    <dd>{{details.urgency}}</dd>
                    <dt>Overtime</dt>
                    <dd>{{details.overtimeApproved ? $t('common.yes') : $t('common.no') }}</dd>
                </dl>
            </el-col>
            <el-col :span="9">
                <dl>
                    <dt>{{$t('serviceTickets.customerName')}}</dt>
                    <dd>{{details.customerName}}</dd>
                    <dt>{{$t('serviceTickets.address')}}</dt>
                    <dd>{{details.customerAddress}}</dd>
                    <dt>{{$t('serviceTickets.phone')}}</dt>
                    <dd>{{details.phone}}</dd>
                    <dt>{{$t('serviceTickets.callBy')}}</dt>
                    <dd>{{details.callBy}}</dd>
                    <dt>{{$t('serviceTickets.callerPhone')}}</dt>
                    <dd>{{details.callerPhoneNumber == null ? '' : details.callerPhoneNumber}}</dd>
                    <dt>{{$t('serviceTickets.status')}}</dt>
                    <dd>
                        <span>{{details.statusText}}</span>
                    </dd>
                </dl>
            </el-col>
            <el-col :span="6">
                <dl>
                    <dt>{{$t('serviceTickets.model')}}</dt>
                    <dd>{{details.model}}</dd>
                    <dt>{{$t('serviceTickets.serial')}}</dt>
                    <dd>{{details.serialNumber}}</dd>
                    <dt>{{$t('serviceTickets.coverage')}}</dt>
                    <dd>{{details.coverage}}</dd>
                    <dt>{{$t('serviceTickets.gasType')}}</dt>
                    <dd>{{details.gasType}}</dd>
                    <dt>{{$t('serviceTickets.warrEnd')}}</dt>
                    <dd>{{details.warrantyEnd | date}}</dd>
                </dl>
            </el-col>
        </el-row>
        <el-row v-if="details.note">
            <h4>{{$t('serviceTickets.communicationRequirements')}}</h4>
            {{details.note}}
        </el-row>
        <el-row>
            <h4>{{$t('serviceTickets.symptoms')}}</h4>
            <el-scrollbar style="margin-bottom: 10px;">
                <table style="width: 100%;">

                    <tbody v-for="complaint in details.complaints"
                           :key="complaint.code">
                        <tr>
                            <td>
                                <h4>{{$t('serviceTickets.symptomCodes')}}</h4>
                            </td>
                            <td>
                                <h4>{{$t('serviceTickets.description')}}</h4>
                            </td>
                        </tr>
                        <tr>
                            <td>{{complaint.code}}</td>
                            <td>{{complaint.description}}</td>
                        </tr>
                        <tr>
                            <td>
                                <h4 style="white-space:pre" v-if="ShowMandatoryParts(complaint)">{{$t('serviceTickets.mandatoryParts')}}</h4>
                            </td>
                            <td>
                                <!--<h4 v-if="ShowMandatoryParts(complaint)">Description</h4>-->
                            </td>
                        </tr>
                        <tr>
                            <td v-if="ShowMandatoryParts(complaint)" style="white-space:pre">{{ShowMandatoryParts(complaint)}}</td>
                            <td v-if="ShowMandatoryParts(complaint)" style="white-space:pre">{{ShowDescriptionForMandatoryParts(complaint)}}</td>
                        </tr>
                        <tr>
                            <td>
                                <h4 style="white-space:pre" v-if="ShowRecommendedParts(complaint)">{{$t('serviceTickets.recommendedParts')}}</h4>
                            </td>
                            <td>
                                <!--<h4 v-if="ShowRecommendedParts(complaint)">Description</h4>-->
                            </td>
                        </tr>
                        <tr>
                            <td v-if="ShowRecommendedParts(complaint)" style="white-space:pre">{{ShowRecommendedParts(complaint)}}</td>
                            <td v-if="ShowRecommendedParts(complaint)" style="white-space:pre">{{ShowDescriptionForRecommendedParts(complaint)}}</td>
                        </tr>
                        <tr>
                            <td>
                                <hr />
                            </td>
                        </tr>
                    </tbody>

                </table>
            </el-scrollbar>
        </el-row>
        <el-row>
            <h4>{{$t('serviceTickets.comments')}}</h4>
            <el-scrollbar style="margin-bottom: 10px;">
                <ul class="comment-box">
                    <li v-for="comment in details.comments"
                        :key="comment.id">
                        <p>
                            {{comment.message}}

                        </p>
                        <small>On {{ showCommentFullTime(comment) }} by {{comment.author}}</small>
                    </li>
                </ul>
            </el-scrollbar>
        </el-row>
        <el-row>
            <h4>What was done?</h4>
            <el-scrollbar style="margin-bottom: 10px;">
                <ul class="comment-box">
                    <li v-for="whatWasDone in details.escalationCommentWhatWasDone"
                        :key="whatWasDone.id">
                        <p>
                            {{whatWasDone.message}}

                        </p>
                        <small>On {{ showCommentFullTime(whatWasDone) }} by {{whatWasDone.author}}</small>
                    </li>
                </ul>
            </el-scrollbar>
        </el-row>
        <el-row>
            <h4>Escalation Next Step</h4>
            <el-scrollbar style="margin-bottom: 10px;">
                <ul class="comment-box">
                    <li v-for="escalationCommentNextStep in details.escalationCommentNextStep"
                        :key="escalationCommentNextStep.id">
                        <p>
                            {{escalationCommentNextStep.message}}

                        </p>
                        <small>On {{ showCommentFullTime(escalationCommentNextStep) }} by {{escalationCommentNextStep.author}}</small>
                    </li>
                </ul>
            </el-scrollbar>
        </el-row>
        <div slot="footer">

            <div style="margin-bottom: 10px;">
                <el-button :disabled="loading"
                           @click="showSubscriptionDialog = true"
                           type="primary">Subscription List</el-button>
                <el-button :disabled="loading"
                           @click="closeDialog">{{$t('serviceTickets.close')}}</el-button>
            </div>
        </div>
        <el-dialog :visible.sync="showSubscriptionDialog"
                   width="650px"
                   style="margin-left: -15px;"
                   append-to-body>
            <el-scrollbar style="margin-bottom: 10px;">
                <h4>Subscription List</h4>
                <el-table :data="subscriberForm"
                          size="mini">
                    <el-table-column prop="name" width="90"
                                     label="Name">
                    </el-table-column>
                    <el-table-column prop="email" width="90"
                                     label="Email">
                    </el-table-column>
                    <el-table-column prop="sms" width="90"
                                     label="Phone Number">
                    </el-table-column>
                    <el-table-column prop="IsSubscribedByEmail" label="Email Subscription" width="100">
                        <template slot-scope="scope">
                            <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                                <el-checkbox class="checkbox" :disabled="true"
                                             v-model="scope.row.isSubscribedByEmail"></el-checkbox>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="IsSubscribedBySms" label="SMS Subscription" width="100">
                        <template slot-scope="scope">
                            <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                                <el-checkbox class="checkbox" :disabled="true"
                                             v-model="scope.row.isSubscribedBySms"></el-checkbox>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-scrollbar>
        </el-dialog>
    </el-dialog>
</template>
<script>
    import api from "../api";
    export default {
        name: "escalation-ticket-details-dialog",
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            ticketId: {
                required: true
            }
        },
        data() {
            return {
                details: {},
                loading: false,
                showDialog: this.visible,
                showSubscriptionDialog: false,
                showImagePreview: false,
                showRsMessage: false,
                statuses: [],
                subscriberForm: [],
            }
        },
        watch: {
            visible: function (val) {
                this.showDialog = val;
            }
        },
        methods: {
            loadTicket() {
                if (this.ticketId) {
                    this.loading = true;
                    api.getTicketDetail(this.ticketId).then(response => {
                        this.loading = false;
                        if (response.data.success) {
                            this.details = Object.assign({}, response.data.ticket);
                            console.log(this.details)
                            if (this.details.isRs) {
                                this.showRsMessage = true;
                            }
                            this.serviceCompanyId = response.data.ticket.serviceCompanyId;
                            this.subscriberForm = response.data.subscriberList;
                        } else {
                            this.$notify({
                                title: "Error",
                                message: response.data.message,
                                type: "error"
                            });
                            this.$emit("dialogClosed");
                        }
                    });
                }
            },
            showCommentFullTime(comment) {
                console.log(comment);
                var commentTime = new Date(comment.at);
                return commentTime.toLocaleString();
            },
            closeDialog() {
                this.showDialog = false;
                this.$emit("dialogClosed");
            },
            ShowRecommendedParts(complaint) {
                if (complaint.partSelected.length > 0) {
                    var recommendedParts = "";
                    complaint.partSelected.forEach(function (element) {
                        if (element.isRecommendedPart && element.part != null) {
                            recommendedParts += '' + element.part.no + '\n';
                        }
                    });
                    return recommendedParts;
                }
                else {
                    return "";
                }

            },

            ShowDescriptionForRecommendedParts(complaint) {
                if (complaint.partSelected.length > 0) {
                    var recommendedPartsDescription = "";
                    complaint.partSelected.forEach(function (element) {
                        if (element.isRecommendedPart && element.part != null) {
                            recommendedPartsDescription += '' + element.part.description + '\n';
                        }
                    });
                    return recommendedPartsDescription;
                }
                else {
                    return "";
                }
            },

            ShowMandatoryParts(complaint) {
                if (complaint.partSelected.length > 0) {
                    var mandatoryParts = "";
                    complaint.partSelected.forEach(function (element) {
                        if (element.isRequiredPart && element.part != null) {
                            mandatoryParts += '' + element.part.no + '\n';
                        }
                    });
                    return mandatoryParts;
                }
                else {
                    return "";
                }
            },

            ShowDescriptionForMandatoryParts(complaint) {
                if (complaint.partSelected.length > 0) {
                    var mandatoryPartsDescription = "";
                    complaint.partSelected.forEach(function (element) {
                        if (element.isRequiredPart && element.part != null) {
                            mandatoryPartsDescription += '' + element.part.description + '\n';
                        }
                    });
                    return mandatoryPartsDescription;
                }
                else {
                    return "";
                }
            }
        }
    }
</script>
<style scoped>
    .comment-input {
        margin-bottom: 0;
    }

        .comment-input > textarea {
            resize: none;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }

    .comment-button {
        width: 100%;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        border-top: 0;
    }

    .comment-box {
        list-style: none;
        padding: 0;
        margin-top: 0;
        max-height: 400px;
    }

        .comment-box > li {
            margin-bottom: 10px;
        }

        .comment-box > p {
            margin-bottom: 0;
        }

    dd {
        margin-left: 0;
        line-height: 16px;
        margin-bottom: 10px;
    }

    dl {
        margin-top: 0;
    }

    dt {
        font-weight: bold;
    }

    dd {
        margin-left: 0;
        line-height: 16px;
        margin-bottom: 10px;
    }
</style>


// WEBPACK FOOTER //
// ClientApp/globalapp/escalationdashboard/components/EscalationListDetailsDialog.vue